<template>
  <a-select
    :disabled="disabled"
    :multiple="false"
    :placeholder="placeholder"
    :value="value"
    allow-clear
    option-filter-prop="title"
    show-search
    @change="onChange"
  >
    <a-select-option
      v-for="item in records"
      :key="byName ? item.serviceClassificationName : item.id"
      :title="item.serviceClassificationName"
      :value="byName ? item.serviceClassificationName : item.id"
      >{{ item.serviceClassificationName }}</a-select-option
    >
    <template #suffixIcon v-if="showAdd">
      <a-tooltip title="去创建">
        <plus-outlined @click="goAdd" />
      </a-tooltip>
    </template>
  </a-select>
</template>

<script lang="ts">
import { ServiceClassificationService } from "@/views/maintenance/serviceClassification/service-classification.service";
import { defineComponent, watch } from "vue";
import { onMountedOrActivated } from "@/core/hooks/onMountedOrActivated";
import { PlusOutlined } from "@ant-design/icons-vue";
import { useRoute, useRouter } from "vue-router";
/**
 * 服务分类
 *
 * 使用方式:
 * <serviceClassification-select v-model:value="formRef.id"></serviceClassification-select>
 */
export default defineComponent({
  isGlobal: true,
  props: {
    value: {
      type: String,
      default: undefined,
    },
    name: {
      type: String,
      default: undefined,
    },
    disabled: {
      type: Boolean,
      default: false,
    },

    placeholder: {
      type: String,
      default: "请选择",
    },
    api: {
      type: String,
    },
    byName: {
      type: Boolean,
      default: false,
    },
    showAdd: {
      type: Boolean,
      default: false,
    },
    ticketTypeId: {
      type: String,
      default: undefined,
    },
    status: {
      type: Number,
      default: 1,
    },
  },
  emits: ["update:value", "change", "update:name"],
  components: {
    PlusOutlined,
    VNodes: (_, { attrs }) => {
      return attrs.vnodes;
    },
  },
  setup(props, { emit }) {
    const router = useRouter();
    const { data: records, run, loading } = ServiceClassificationService.useSimpleListApi();
    const onChange = async (id) => {
      let item: any = {};
      if (props.byName) {
        item = (records.value || []).find((e) => e.serviceClassificationName == id);
        emit("update:value", item.serviceClassificationName);
        emit("change", item.serviceClassificationName);
      } else {
        item = (records.value || []).find((e) => e.id == id);
        emit("update:value", id);
        emit("change", id);
      }
      // console.log("🚀 ~ file: index.vue:63 ~ onChange ~ item:", item);
    };
    watch(
      () => props.ticketTypeId,
      async (n) => {
        if (n) {
          if (props.byName) {
            await run(
              { ticketTypeId: props.ticketTypeId, status: props.status },
              "/maintenance_service_classification/simpleName/list"
            );
          } else {
            await run({ ticketTypeId: props.ticketTypeId, status: props.status });
          }
        }
      }
    );

    onMountedOrActivated(async () => {
      if (props.byName) {
        await run(
          { ticketTypeId: props.ticketTypeId, status: props.status },
          "/maintenance_service_classification/simpleName/list"
        );
      } else {
        await run({ ticketTypeId: props.ticketTypeId, status: props.status });
      }

      // console.log("🚀 ~ file: index.vue:65 ~ onMounted ~ records:", records);
    });
    const goAdd = () => {
      router.push("/maintenanceSetting/serviceClassification");
    };
    return {
      records,
      loading,
      onChange,
      goAdd,
    };
  },
});
</script>
